import { ICartStateGeneric } from '@signature-it/ngx-catalogue/store/interfaces';
import { createFeatureSelector } from "@ngrx/store";
// DO NOT MOVE IT - ITS FOR COMPILATION
import { CodescDTO } from '@signature-it/ngx-generic/models';
import { GetTemporaryTransactionDTO , CartTotalQuantityDTO, CartTotalPriceDTO} from '@signature-it/ngx-catalogue/models';

export const getCartState = createFeatureSelector<ICartStateGeneric>('cartState');
export const getCart = store => getCartState(store).cart;
export const getCartItemsQuantity = store => getCartState(store).itemsQuantity;
export const getCartTotalPrice = store => getCartState(store).totalPrice;
export const getProcessingGetCart = store => getCartState(store).processingGetCart;
export const getProcessingAddToCart = store => getCartState(store).processingAddToCart;
export const getLoadingUpdatedCart = store => getCartState(store).loadingUpdatedCart;
export const getLoadingTotalPrice = store => getCartState(store).loadingTotalPrice;
export const getTotalPriceError = store => getCartState(store).totalPriceError;
export const getLoadingTotalQuantity = store => getCartState(store).loadingTotalQuantity;
export const getProcessingCheckout = store => getCartState(store).processingCheckout;
export const getProcessingCheckoutCG = store => getCartState(store).processingCheckoutCG;
export const getProcessingCheckoutPCC = store => getCartState(store).processingCheckoutPCC;
export const getProcessingCheckoutPFT = store => getCartState(store).processingCheckoutPFT;
export const getAddToCartOpenModal = store => getCartState(store).addToCartOpenModal;
export const getRedirectLink = store => getCartState(store).redirectLink;
export const getAddToCartAfterRemove = store => getCartState(store).addToCartAfterRemove;
export const getAddToCartError = store => getCartState(store).addToCartError;
export const getCheckoutError = store => getCartState(store).checkoutError;
export const getUpdatedCartSuccess = store => getCartState(store).updatedCartSuccess;
export const getSkipModalAfterAddToCart = store => getCartState(store).skipModalAfterAddToCart;
export const getCartShippingMethods = store => getCartState(store).shippingMethods;
export const getLoadingShippingMethods = store => getCartState(store).loadingShippingMethods;
export const getRemoveAllItemsError = store => getCartState(store).removeAllItemsError;
